module.exports = new __parcel__URL__("Sales Account Planning Hover.e1bd2a06.svg").toString();